import React, { Component } from 'react';
import CurrencyInput from 'react-currency-input';

export default class ReportViewRow extends Component {
  render() {
    const rowData = this.props.rowData;
    return (
      <tr>
        <td role="button" onClick={()=>this.props.toggleModal(rowData)}>{rowData.Name}</td>
        <td>{rowData.Description}</td>
        <td>{rowData.Tag}</td>
        <td>{rowData.Status.Name}</td>
        <td>{rowData.Type.Name}</td>
        <td>{rowData.Owner.FirstName}&nbsp;{rowData.Owner.LastName}</td>
        <td>{rowData.Site.Name}</td>
        <td>{rowData.Location.Name}</td>
        <td>{rowData.PurchaseBy.FirstName}&nbsp;{rowData.PurchaseBy.LastName}</td>
        <td>{rowData.PurchasedDate}</td>
        <td style={{'fontSize':'12px'}}>{rowData.PurchaseOrder}</td>
        <td className="align-right">
          <CurrencyInput 
            style={{'textAlign': 'right','border': 'none','background': 'transparent'}}
            prefix ={rowData.PurchaseCurrencyAbbr +" "} 
            value  ={rowData.PurchasePrice} 
            readOnly
          />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/report/helper/component/Report/ReportViewRow.js